import { useEffect } from 'react';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import { getTelegramWebApp } from '@24i/nxg-sdk-higgs/src/utils';
import { getDeepLinkWebRoute } from './utils';
import { SOTT_DEFAULT_WEB_SCREENS } from '../../navigation/constants';
import { ApplicationStates, useAppStart } from '../../context/AppStartContext';

export const useTelegramBotDeepLinking = () => {
    const deepLinkingEnabled = useFeature('deepLinking')?.enabled || false;
    const { appState } = useAppStart();
    const router = useRouter();
    const telegramApp = getTelegramWebApp();

    const deepLinkPath = telegramApp?.initDataUnsafe?.start_param || '';

    useEffect(() => {
        if (
            !deepLinkingEnabled ||
            !router?.isReady ||
            !deepLinkPath ||
            appState !== ApplicationStates.initialNavigationComplete
        )
            return;

        const routeLink = getDeepLinkWebRoute(deepLinkPath as string);

        const target =
            routeLink?.href && routeLink?.as ? routeLink : SOTT_DEFAULT_WEB_SCREENS.Home.getLink();

        router.push(target.href, target.as);
    }, [deepLinkingEnabled, router?.isReady, deepLinkPath, appState]);
};
